function isLoading(state) {
  return state.isLoading;
}

function masterData(state) {
  return state.masterData;
}

function files(state) {
  return state.files;
}

const MasterDataGetters = {
  isLoading,
  masterData,
  files,
};

export default MasterDataGetters;
